module.exports = __webpack_public_path__ + "img/iconYearly.df3456f2.png";